/**
 * Created by slava on 23.03.17.
 */

const CharView = {
    Create: function (symbol, options) {
        const styles = cleverapps.styles.CharView;

        let bg;
        if (options.noBg) {
            bg = new cc.Node();
            bg.setContentSize2(styles);
            bg.setAnchorPoint(0.5, 0.5);
        } else {
            bg = new cc.Sprite(CharView.GetImage(options));
        }

        if (["ss", "SS", "ß"].indexOf(symbol) !== -1) {
            symbol = "ß";
        }

        const charView = bg.letter = CharView.GetView(symbol, options);
        charView.setPosition(bg.width / 2, bg.height / 2 + CharView.CalcCharPadding(options));
        charView.setLocalZOrder(2);
        bg.addChild(charView);

        bg.setCascadeColorEnabled(true);
        bg.setCascadeOpacityEnabled(true);

        return bg;
    },

    CalcCharPadding: function (options) {
        const styles = cleverapps.styles.CharView;

        if (options.noBg) {
            return styles.topPadding;
        }
        return styles.topPaddingWithBg;
    },

    GetImage: function (options) {
        if (options.bgImage) {
            return options.bgImage;
        }
        return bundles.letters.frames.letter_bg_png;
    },

    GetView: function (symbol, options) {
        options = options || {};

        const customFont = CharView.FONTS[cleverapps.settings.language + (options.whiteLetter ? "" : "_board")];
        if (customFont) {
            // eslint-disable-next-line no-restricted-syntax
            return cleverapps.UI.generateTTFText(symbol.toUpperCase(), customFont);
        }

        const font = cleverapps.styles.FONTS[options.whiteLetter ? "LETTERS_TEXT" : "BOARD_TEXT"];

        // eslint-disable-next-line no-restricted-syntax
        return cleverapps.UI.generateTTFText(symbol.toUpperCase(), options.font || font);
    }
};

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    BOARD_TEXT: new cc.Color(255, 255, 255, 255),
    KEYPAD_LETTERS: new cc.Color(255, 255, 255, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    KOREAN_LETTERS_TEXT: {
        font: bundles.letters_ko.urls.korean_ttf,
        size: 80,
        color: cleverapps.styles.COLORS.WHITE
    },
    JAPANESE_LETTERS_TEXT: {
        font: bundles.letters_ja.urls.japan_ttf,
        size: 80,
        color: cleverapps.styles.COLORS.KEYPAD_LETTERS
    },
    JAPANESE_BOARD_TEXT: {
        font: bundles.letters_ja.urls.japan_ttf,
        size: 80,
        color: cleverapps.styles.COLORS.BOARD_TEXT
    }
});

CharView.FONTS = {};
CharView.FONTS[cc.sys.LANGUAGE_JAPANESE] = cleverapps.styles.FONTS.JAPANESE_LETTERS_TEXT;
CharView.FONTS[`${cc.sys.LANGUAGE_JAPANESE}_board`] = cleverapps.styles.FONTS.JAPANESE_BOARD_TEXT;
CharView.FONTS[cc.sys.LANGUAGE_KOREAN] = cleverapps.styles.FONTS.KOREAN_LETTERS_TEXT;

cleverapps.styles.CharView = {
    width: 92,
    height: 92,
    topPadding: 0,
    topPaddingWithBg: 0
};